import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'd2-pagination',
  props: {
    current: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onSizeChange: function onSizeChange() {
      this.$emit('change');
    },
    onCurrentChange: function onCurrentChange() {
      this.$emit('change');
    }
  }
};